exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".HomeDialog-header[data-v-19f52d55]{display:flex;align-items:center;justify-content:space-between;background-color:#eee;font-size:16px;padding:0 10px 0 30px;margin:20px 0}.HomeDialog-main[data-v-19f52d55]{padding:0 10px}.img-wrap[data-v-19f52d55]{width:100%;height:100%;object-fit:contain;display:flex;align-items:center;justify-content:center;padding:18px 0}.img-wrap img[data-v-19f52d55]{width:100px;height:100px;object-fit:contain}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-19f52d55&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/HomeDialog/index.vue
// module id = 460
// module chunks = 0